<template>
    <div style="width:99%">
        <Tabs type="card" :animated="false">
            <TabPane label="基础信息"><AchAssessComponentTab1></AchAssessComponentTab1></TabPane>
            <TabPane label="十五宫格"><AchAssessComponentCell></AchAssessComponentCell></TabPane>
        </Tabs>
        
    </div>
</template>


<script>
import './js/westeros.js'
import axios from 'axios'
import AchAssessComponentTab1 from './components/AchAssessComponentTab1'
import AchAssessComponentCell from './components/AchAssessComponentCell'
export default {
    components:{AchAssessComponentTab1,AchAssessComponentCell},
    data(){
        return{
            loading:false,
            spinShow:false,
            modalSpinShow:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columns:[
                {
                    title: '员工姓名',
                    key: 'name',
                    minWidth: 150,
                    align: "center"
                },
                {
                    title: '员工号',
                    align: "center",
                    key: 'number',
                    minWidth: 180,
                },
                {
                    title: '业务单元',
                    align: "center",
                    key: 'unit',
                    minWidth: 100,
                },
                {
                    title: '职位',
                    align: "center",
                    key: 'position',
                    minWidth: 160,
                },
                {
                    title: '直接上级',
                    align: "center",
                    key: 'higher',
                    minWidth: 160,
                },
                {
                    title: '部门',
                    align: "center",
                    key: 'department',
                    minWidth: 160,
                },
                {
                    title: '年度',
                    align: "center",
                    key: 'year',
                    minWidth: 100,
                },
                {
                    title: 'What-经理评分',
                    align: "center",
                    key: 'whatScore',
                    minWidth: 160,
                },
                {
                    title: 'How-经理评分',
                    align: "center",
                    key: 'howScore',
                    minWidth: 160,
                },
                {
                    title: 'Overall-经理评分',
                    align: "center",
                    key: 'overallScore',
                    minWidth: 160,
                },
                {
                    title: '潜能评估',
                    align: "center",
                    key: 'potential',
                    minWidth: 160,
                },
                {
                    title: '查看',
                    align: "center",
                    slot: "slot",
                    width: 100,
                    fixed: 'right',
                }
            ],
            dataTable:[
                {name:'A1',number:'0001',unit:'',position:'',higher:'',department:'',year:'2022',whatScore:'10',howScore:'9',overallScore:'9',potential:'良好'},
                {name:'A2',number:'0002',unit:'',position:'',higher:'',department:'',year:'2022',whatScore:'6',howScore:'7',overallScore:'10',potential:'良好'},
                {name:'A3',number:'0003',unit:'',position:'',higher:'',department:'',year:'2022',whatScore:'9',howScore:'8',overallScore:'9',potential:'良好'},
                {name:'A4',number:'0004',unit:'',position:'',higher:'',department:'',year:'2022',whatScore:'10',howScore:'10',overallScore:'10',potential:'良好'},
                {name:'A5',number:'0005',unit:'',position:'',higher:'',department:'',year:'2022',whatScore:'8',howScore:'7',overallScore:'10',potential:'良好'}
            ],
            showinfoModal:false,
            dataListName:[]
        }
    },
    mounted(){
        this.barLeftChart()
    },
    methods:{
        barLeftChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('barLeftChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                // title: {
                //     text: '绩效正态分布-Overall',
                //     left: 'center'
                // },
                 tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    }
                },
                grid:{
                    left:'6%',
                    right:'18%',
                    top:'4%',
                    bottom:'10%'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['1', '2', '3', '4', '5'],
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        min: 0,
                        max: 4.5,
                        interval: 0.5,
                        axisLabel: {
                            formatter: '{value}'
                        },
                    },
                    {
                        type: 'value',
                        min: 0,
                        max: 0.35,
                        interval: 0.05,
                        axisLabel: {
                            formatter: '{value}'
                        },
                    }
                ],
                
                series: [
                    {
                        name: '绩效',
                        type: 'bar',
                        barWidth: '50%',
                        color:'#4ea397',
                        data: [
                            {
                                value: 1,
                                itemStyle: {
                                    color: '#9BC2E6'
                                }
                            },
                            {
                                value: 2,
                                itemStyle: {
                                    color: '#CA6A2A'
                                }
                            },
                            {
                                value: 4,
                                itemStyle: {
                                    color: '#A5A5A5'
                                }
                            },
                            {
                                value: 3,
                                itemStyle: {
                                    color: '#D9A300'
                                }
                            },
                            {
                                value: 2,
                                itemStyle: {
                                    color: '#4472C4'
                                }
                        }]
                    },
                    {
                        name: '绩效1',
                        type: 'line',
                        color:'#22c3aa',
                        data: [1,2,4,3,1]
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
        showInfoClick(num){
            this.dataListName=[]
            let obj = {
                empCode:'',
                chName:'',
                pageNo: 1,
                pageSize: num
            }
            this.showinfoModal=true
            this.modalSpinShow=true
            axios.post("/userListRole/selectUserListColumnSetData", obj).then((res) => {
                if (res) {
                    this.dataListName = res.tableData.data.data
                    this.modalSpinShow=false
                }
            })
        },
        getData(){},
        openPop(row){},
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
    }
}
</script>

<style lang="less" scoped>

.chartBox {
    display: flex;
    margin-top: 100px;
    
    .chartCol {
        width:48%;
        margin-right: 2%;
        height: 500px;
        box-sizing: border-box;
    }
    .chartCol1 {
        width:50%;
        height: 500px;
        box-sizing: border-box;
    }
}
@media screen and (max-width: 1440px) {
    .chartBox {
        display: flex;
        margin-top: 100px;
        flex-wrap: wrap;
        .chartCol {
            width:100%;
            margin-right: 0;
            height: 420px;
            box-sizing: border-box;
        }
        .chartCol1 {
            width:100%;
            height: 420px;
            box-sizing: border-box;
        }
    }
}
.chartTit {
    font-size: 20px;
    font-weight: bold;
    color: #4ea397;
    text-align: center;
    margin: 0px 0 30px 0;
}
.patentialRow {
    margin-top: 8px;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    span{
        display: block;
        text-align: right;
       margin-right: 20px;
    }
}

.potentialBox {
    width: 96%;
    height: 80px;
    border: 1px solid #cccccc;
    border-radius: 10px;
    line-height: 80px;
    text-align: center;
    cursor: pointer;
    font-size: 22px;
}
.potentialBox:hover{
    opacity: 0.5;
}
.potentialBoxBackground1 {
    background-image: linear-gradient(45deg,#dfdfdf 25%,white 0,white 50%,#dfdfdf 0,#dfdfdf 75%,white 0);
    background-size: 6px 6px;
}
.potentialBoxBackground2 {
   background-color: rgb(0, 50, 30);
   color: white;
}
.potentialBoxBackground3 {
    background-color: rgb(23, 177, 105);
}
.potentialBoxBackground4 {
   background-color: rgb(255, 180, 0);
}
.potentialBoxBackground5 {
    background-color: rgb(180, 145, 50);
}
.modalListBox {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
}

</style> 


// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchAssess.vue